import styled from '@emotion/styled'

export const Form = styled.form({
  margin: 0,
  padding: 0,
})
